<div class="form-wrapper">
    <mat-card appearance="outlined">
        <!-- prettier-ignore -->
        <div class="hydrao-card-title" i18n="@@register.confirmAccount.title">Confirm your account</div>
        <!-- prettier-ignore -->
        <div class="intro-text" i18n="@@register.confirmAccount.explaination">Your have to confirm your account. An email has been sent with a code to the email <b>{{email}}</b>. Please enter the code below.</div>
        <form [formGroup]="confirmAccountForm" autocomplete="off" novalidate (ngSubmit)="confirmAccount(confirmAccountForm.value)"
            fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
            <mat-form-field>
                <input required matInput i18n-placeholder placeholder="Confirmation code" type="text" formControlName="confCode"
                    id="confCode" autofocus>
                <!-- prettier-ignore -->
                <mat-error *ngIf="hasError('confCode', 'required')" i18n="@@register.confirmAccount.codeRequired">Confirmation code is required</mat-error>
                <!-- prettier-ignore -->
                <mat-error *ngIf="hasError('confCode', 'pattern')" i18n="@@register.confirmAccount.codeLength">Confirmation code should be 6 digits long.</mat-error>
            </mat-form-field>

            <div class="buttons">
                <!-- prettier-ignore -->
                <button mat-flat-button color="primary" [disabled]="!confirmAccountForm.valid" i18n="@@register.confirmAccount.confirmAccount">confirm account</button>
                <!-- prettier-ignore -->
                <button mat-button type="button" color="primary" i18n="@@register.confirmAccount.resendEmail" (click)="resendCode()">resend email</button>
            </div>
            <div class="error mat-error" *ngIf="errorCode" [ngSwitch]="errorCode">
                <!-- prettier-ignore -->
                <div *ngSwitchCase="'CodeMismatch'" i18n="@@register.confirmAccount.invalidCode">The code you entered is invalid, please verify</div>
                <!-- prettier-ignore -->
                <div *ngSwitchDefault i18n="@@global.error.unexpectedError">Unexpected error, please try again</div>
            </div>
        </form>
    </mat-card>
</div>